import styled from '@emotion/styled';
import React from 'react';
import { breakpoints, AuthActions, Button } from 'gatsby-theme-apollo';
import EditableText from './editable-text';

const StyledTextForm = styled.div({
  display: `flex`,
  flexDirection: `row`,
  justifyContent: `center`,
  alignItems: `center`,
  flexWrap: `wrap`,
  width: `100%`,
  [` > input`]: {
    marginRight: `10px`,
    padding: `7px`
  },
  [breakpoints.sm]: {
    [`> input`]: {
      marginBottom: `10px`,
      marginRight: `0px`
    }
  }
});

const TextForm = ({ placeholder, onFocus, onChange, onSignIn, onSubmit, value, contentType }) => {
  return (
    <StyledTextForm>
      <EditableText
        minWidth="290px"
        placeholder={placeholder}
        maxCharacters={200}
        textValue={value}
        dark
        onInputChanged={onChange}
        onFocus={onFocus}
      />
      <AuthActions
        hideSignOut
        forcePrimary
        intent={`submit_${contentType}`}
        uiSource="text-form"
        cta={`Submit ${contentType}`}
        onSignIn={onSignIn}
      >
        <Button primary onClick={onSubmit}>
          {`Submit ${contentType}`}
        </Button>
      </AuthActions>
    </StyledTextForm>
  );
};

export { TextForm };
